import { createFileRoute } from '@tanstack/react-router';
import { FormShareTab } from '@web/modules/forms/share/form-share-tab';

export const Route = createFileRoute('/_app/capture/forms/$formId/share')({
  component: FormShareTab,
});
